/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  useRef, useState, FC, useEffect,
} from 'react';
import {
  Autocomplete,
  Typography,
  IconButton,
} from '@mui/material';
import StyledIconedBox, {
  StyledTextField,
  StyledAutoCompleteMenu,
} from 'views/rebranded-module/GeoViewV2/components/GeoLocationField/GeoLocationField.styles';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import CloseIcon from '@mui/icons-material/Close';
import {
  PICKUP_LOCATION,
  DROPOFF_LOCATION,
  placeSlugTypes,
} from 'views/GeoView/utils/constants';
import { RiMapPinLine, RiFlightTakeoffLine } from 'react-icons/ri';

const GeoLocationField:FC<any> = (props) => {
  const {
    icon,
    fieldType,
    placeholder,
    className,
    fullWidthMenu,
    value,
    handleClearRangePicker,
    onChange,
    rentalData,
    ...restOfProps
  } = props;
  const firstLiRef = useRef(null);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const [isFieldFocused, setIsFieldFocused] = useState(false);
  const renderOptionIcon = (type) => {
    switch (type) {
      case placeSlugTypes[0]:
        return <RiFlightTakeoffLine className="GLFOptionIcon" />;
      case placeSlugTypes[1]:
        return <RiFlightTakeoffLine className="GLFOptionIcon" />;
      default:
        return <RiMapPinLine className="GLFOptionIcon" />;
    }
  };
  const renderOption = (optionProps, option) => {
    switch (fieldType) {
      case PICKUP_LOCATION:
        if (option.id === null) {
          return (
            <>
              <li
                {...optionProps}
                ref={firstLiRef}
                className={`${optionProps.className} GLFOption GLFUseCurrentOption`}>
                <MyLocationIcon className="GLFOptionIcon" />
                <Typography component="p" className="GLFOptionTitle">
                  {option.name}
                </Typography>
              </li>
              <li
                {...optionProps}
                className={`${optionProps.className} GLFOption GLFUseCurrentOption fixedOption`}>
                <MyLocationIcon className="GLFOptionIcon" />
                <Typography component="p" className="GLFOptionTitle">
                  {option.name}
                </Typography>
              </li>
            </>
          );
        }
        return (
          <li
            {...optionProps}
            className={`${optionProps.className} GLFOption GLFPickupDropdown`}>
            {renderOptionIcon(option.placeable?.type)}
            <Typography component="p" className="GLFOptionTitle">
              {option.name}
              <Typography component="span" className="GLFOptionSubtitle">
                {option.short_name}
              </Typography>
            </Typography>
          </li>
        );
      case DROPOFF_LOCATION:
      default:
        return (
          <li
            {...optionProps}
            className={`${optionProps.className} GLFOption GLFDropoffOption`}>
            <RiMapPinLine className="GLFOptionIcon GLFDropoffOptionIcon" />
            <Typography
              component="p"
              className="GLFOptionTitle GLFDropoffOptionTitle">
              {option.name}
            </Typography>
          </li>
        );
    }
  };

  useEffect(() => {
    if (rentalData && inputRef.current) {
      inputRef.current.blur();
    }
  }, [rentalData]);

  return (

    <StyledIconedBox
      Icon={icon}
      size={18}
      className={className}
      focused={isFieldFocused || !!value}>
      <Autocomplete
        fullWidth
        value={isFieldFocused ? null : value}
        popupIcon=""
        PaperComponent={StyledAutoCompleteMenu}
        disableClearable
        componentsProps={{
          paper: {
            classes: {
              root: fullWidthMenu && 'fullWidth',
            },
            fieldType,
            useMyLocationHeight: firstLiRef?.current?.clientHeight,
            useMyLocationWidth: firstLiRef?.current?.clientWidth,
          },
        }}
        renderInput={(params) => (
          <>
            <StyledTextField
              className="GLFTextField"
              {...params}
              fullWidth
              inputRef={inputRef}
              onFocus={() => setIsFieldFocused(true)}
              onBlur={() => setIsFieldFocused(false)}
              placeholder={placeholder}
              variant="standard"

            />
          </>
        )}
        renderOption={renderOption}
        onChange={(...args) => {
          onChange(...args);
        }}
        {...restOfProps}
      />
      {handleClearRangePicker && (
        <IconButton onClick={handleClearRangePicker} className="GLFCloseButton">
          <CloseIcon />
        </IconButton>
      )}
    </StyledIconedBox>

  );
};

export { GeoLocationField };
